<template>
    <label class="main" :style="{'width': elWidth, 'height': elHeight}">
        <v-icon v-if="url == null || url == ''" size="40">mdi-image</v-icon>
        <img v-if="url != null && url != ''" :src="url" :style="{'width': elWidth, 'height': elHeight}">
        <v-progress-linear
                v-if="loading"
                style="position: absolute; bottom: 0"
                indeterminate
                color="cyan"
        ></v-progress-linear>
        <input type="file" style="display: none" @change="uploadFile">
    </label>
</template>

<script>
    import {HTTP} from "../../../axios";

    export default {
        name: "ImageUploader",
        props: [
            'value',
            'width',
            'height'
        ],
        data(){
            return{
                loading: false,
                url: this.value
            }
        },
        computed:{
            elWidth(){
                return this.width ? (this.width + "px") : "auto"
            },
            elHeight(){
                return this.height ? (this.height + "px") : "auto"
            },
        },
        watch: {
            url(){
                this.$emit('input', this.url)
            }
        },
        methods:{
            uploadFile(event){
                this.loading = true;
                var postData = new FormData()
                postData.append('file', event.target.files[0])
                HTTP
                    .post('files', postData)
                    .then(r => {
                        this.url = r.data.file.url
                        this.loading = false
                    })
            }
        }
    }
</script>

<style scoped>
    .main{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;
    }
</style>